<script setup lang="ts">
const { logoImg = '/_nuxt3-static/logos/logo.svg' } = defineProps<{
  logoImg?: string
}>()
</script>

<template>
  <div>
    <NuxtLazyHydrate when-idle>
      <CartSidebar />
    </NuxtLazyHydrate>

    <nav class="bg-white border-b border-gray-100">
      <div
        class="max-w-(--breakpoint-xl) flex flex-wrap items-center justify-between mx-auto px-4 py-2 h-[70px]"
      >
        <NuxtLinkLocale :to="'/'">
          <img :src="logoImg" class="h-6" alt="konfetti logo" />
        </NuxtLinkLocale>
        <NuxtLazyHydrate when-idle>
          <NavbarUserMenu :hide-account-icon="true" />
        </NuxtLazyHydrate>
      </div>
    </nav>
  </div>
</template>
